<template>
  <div class="split"></div>
</template>

<script>
export default {
  name: 'split'
}
</script>

<style lang="stylus" scoped>
  .split
    width: 100%
    height: 0.8rem
    border-top: 1px solid $color-row-line
    border-bottom: 1px solid $color-row-line
    background: #f3f5f7
</style>
